import store from '@/core/store'
import { setThreads, updateThread, _setFilter, _setFilterMode, _setLoadingStatus, _setPages, _setViewType } from '@/core/store/Slices/ThreadsSlice'
import { cloneDeep } from 'lodash'

export function setStoredThreads (threads) {
  Object.values(threads).map((thread) => {
    threads[thread.composedid] = buildThreadTree(thread)
    return true
  })

  store.dispatch(setThreads(threads))
  store.commit('THREADS:UPDATED', threads)
}

export function getThreads () {
  return store.getState().threads.threads
}

function buildThreadTree (thread) {
  const threadMessages = thread.messages
  if (!threadMessages) return
  threadMessages.map((message) => {
    if (message.isParentOfThreadId) {
      const subthread = thread.subthreads && thread.subthreads[message.isParentOfThreadId]
      message.subthread = subthread
    }
    return message
  })
  return thread
}

export function addReplyMessageToThread (threadId, message, thread) {
  const threads = cloneDeep(getThreads())

  if (thread?.rootThreadId) {
    // Subthread response
    threads[thread.rootThreadId].subthreads[threadId].messages.push(message)
    threads[thread.rootThreadId] = buildThreadTree(threads[thread.rootThreadId])
    store.dispatch(
      setThreads(
        threads
      )
    )
    store.commit(`THREAD:${thread.rootThreadId}:UPDATE:REPLY_ADDED`, threads[thread.rootThreadId])
  } else {
    // main Thread response
    threads[threadId].messages.push(message)
    store.dispatch(
      setThreads(
        threads
      )
    )
    store.commit(`THREAD:${threadId}:UPDATE:REPLY_ADDED`, threads[threadId])
  }
}

export function markThreadAsDeleted (threadId, value) {
  const threadObjects = cloneDeep(getThreads())
  if (!threadObjects[threadId]) return
  const thread = threadObjects[threadId]
  thread.isDeleted = value
  setStoredThreads(threadObjects)
  store.commit(`THREAD:${thread.composedid}:RENDER`, thread)
}

/** START FILTER HANDLER NECESSARY METHODS */

export function setFilterMode (unread) {
  store.dispatch(_setFilterMode(unread))
}

export function getFilterMode () {
  return store.getState().threads.filteringMode
}

export function setFilter (filter) {
  store.dispatch(_setFilter(filter))
}

export function getFilter () {
  return store.getState().threads.currentFilter
}

export function getPages () {
  return store.getState().threads.pages
}

export function setPages (pages) {
  store.dispatch(_setPages(pages))
}

export function getCurrentFilterPage () {
  const currentFilter = getFilter()
  return getFilterPageForFilter(currentFilter)
}

export function getFilterPageForFilter (filter) {
  const key = filter.value?.toLowerCase()
  const subcategory = filter.type?.toLowerCase()
  const pages = getPages()
  return pages[subcategory][key]
}

export function setPaginationDataForFilter (filter, page, paginationData) {
  const key = filter.value?.toLowerCase()
  const subcategory = filter.type?.toLowerCase()
  const pages = cloneDeep(getPages())
  pages[subcategory][key] = {
    page,
    next: paginationData.next || undefined,
  }
  setPages(pages)
}

export function setPaginationDataForCurrentFilter (page, paginationData) {
  const currentFilter = getFilter()
  setPaginationDataForFilter(currentFilter, page, paginationData)
}

export function getLoadingStatus () {
  return store.getState().threads.isLoadingData
}

export function setLoadingStatus (value) {
  store.dispatch(_setLoadingStatus(value))
}

export function setViewType (value) {
  store.dispatch(_setViewType(value))
}

export function getNextPageForCurrentFilter () {
  return getCurrentFilterPage().next
}
/** END FILTER HANDLER NECESSARY METHODS */

export function markMessageOfThreadAsRead (threadId, messageId) {
  const thread = getThreads()[threadId]
  const _thread = JSON.parse(JSON.stringify(thread))
  _thread.messages = _thread.messages.map((message) => {
    if (message.id === messageId) {
      message.unopen = false
    }
    return message
  })
  store.dispatch(updateThread(thread))
  store.commit('THREADS:UPDATED')
}
